import { useTranslations } from 'next-intl';

interface TranscriptRemoveConfirmProps {
  isVisible: boolean;
  title: string;
  onConfirm: () => void;
  onCancel: () => void;
}

export const TranscriptRemoveConfirm: React.FC<TranscriptRemoveConfirmProps> = ({
  isVisible,
  title,
  onConfirm,
  onCancel,
}) => {
  const t = useTranslations('features');

  if (!isVisible) return null;

  return (
    <div
      className="flex flex-col items-center justify-center absolute bottom-full left-1/2 transform -translate-x-1/2 z-10 bg-white w-[300px] h-[104px]"
      style={{
        borderRadius: '4px',
        boxShadow: '0px 2px 15px 0px rgba(163, 168, 173, 0.22)',
      }}
    >
      <div className="flex items-center justify-center w-full text-sm mt-5">{title}</div>
      <div className="flex flex-row items-center justify-center gap-[8px] py-5">
        <button
          className="flex items-center justify-center whitespace-nowrap font-bold text-sm select-none h-6 px-6 text-cyan-900 hover:text-cyan-700 active:text-cyan-700 border border-cyan-900 hover:border-cyan-700 active:border-cyan-700  rounded-md transition"
          onClick={onCancel}
        >
          {t('transcript.no')}
        </button>
        <button
          className="flex items-center justify-center whitespace-nowrap font-bold text-sm select-none h-6 px-6 bg-cyan-900 hover:bg-cyan-700 active:bg-cyan-700 text-white  rounded-md transition"
          onClick={onConfirm}
        >
          {t('transcript.yes')}
        </button>
      </div>
    </div>
  );
};
